import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as DropDownConst from '../../../../store/Reducer/DropDownConst'
import * as common from "../../../../const/Common/CommonFunc";
import {Button, Form, Icon, Input, Label} from 'semantic-ui-react'
import * as Validator from '../../../../util/Validator'
import * as EmailValidator from "email-validator/index";
import $ from "jquery";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import './CreateUser.css'
import AzureSyncUsers from "../AzureSyncUsers/AzureSyncUsers";
import apiConfig from "../../../../axios/axios_api_services";
import UploadCSV from "./UploadCSV/UploadCSV";
import {Checkbox} from "semantic-ui-react";
import StarPicker from 'react-star-picker';

class App extends Component {

  state = {
    formData: {
      title: {
        value: '',
        valid: false
      },
      firstName: {
        value: '',
        valid: false
      },
      lastName: {
        value: '',
        valid: false
      },
      email: {
        value: '',
        valid: false
      },
      mobileNo: {
        value: '',
        valid: false
      },
      identificationType: {
        value: '',
        valid: false
      },
      identificationValue: {
        value: '',
        valid: false
      },

      address_line_1: {
        value: '',
        valid: false
      },
      address_line_2: {
        value: '',
        valid: false
      },
      country: {
        value: 'Sri Lanka',
        valid: false
      },
      province_state: {
        value: '',
        valid: false
      },
      district: {
        value: '',
        valid: false
      },
      city_town: {
        value: '',
        valid: false
      },
      zip: {
        value: '',
        valid: false
      },

      emgFullName: {
        value: '',
        valid: false
      },
      emgMobileNo: {
        value: '',
        valid: false
      },

      empId: {
        value: '',
        valid: false
      },

      department: {
        value: '',
        valid: false
      },
      budgetRef: {
        value: '',
        valid: false
      },
      otherRef: {
        value: '',
        valid: false
      },

      gender: {
        value: '',
        valid: false
      },
      designation: {
        value: '',
        valid: false
      },
      extension: {
        value: '',
        valid: false
      },

    },
    isVIP: false,
    rating: 0,
    departmentData_list: [],
    completeCopUser: false,
    completeEmg: false,
    completeCompany: false,
    formValidate: false,

    azurePopup: false,
    azureResponse: {
      totalCount: 0,
      unsavedUserList: []
    }
  };

  azurePopupHandler = (obj) => {
    this.setState({
      azureResponse: obj,
      azurePopup: !this.state.azurePopup
    })
  };

  clearFields = () => {
    this.setState({
      formData: {
        title: {value: this.state.formData.title.value},
        firstName: {value: ''},
        lastName: {value: ''},
        email: {value: ''},
        mobileNo: {value: ''},
        identificationType: {value: this.state.formData.identificationType.value},
        identificationValue: {value: ''},

        address_line_1: {value: ''},
        address_line_2: {value: ''},
        country: {value: 'Sri Lanka'},
        province_state: {value: this.state.formData.province_state.value},
        district: {value: this.state.formData.district.value},
        city_town: {value: ''},
        zip: {value: ''},

        emgFullName: {value: ''},
        emgMobileNo: {value: ''},

        empId: {value: ''},

        department: {value: this.state.formData.department.value},
        budgetRef: {value: ''},
        otherRef: {value: ''},

        gender: {value: this.state.formData.gender.value},
        designation: {value: ''},
        extension: {value: ''},
      },
      isVIP: false,
      rating: 0,
      completeCopUser: false,
      completeEmg: false,
      completeCompany: false,
      formValidate: false,
    })
  };

  removeBorders = () => {
    this.setState({
      completeCopUser: null,
      completeEmg: null,
      completeCompany: null,
    })
  };

  isValidate = () => {
    this.removeBorders();
    let isCorporate = this.validateCorporate();
    if (isCorporate) {
      swal({
        title: "Are you sure do you want to add this user?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            this.submitForm();
            break;
          default:
            break;
        }
      });


    }
  };

  validateCorporate = () => {
    if (this.state.formData.title.value.trim() === ""
      || this.state.formData.firstName.value.trim() === ""
      || this.state.formData.lastName.value.trim() === ""
      || this.state.formData.gender.value.trim() === ""
      || this.state.formData.mobileNo.value.trim() === ""
      || this.state.formData.identificationType.value.trim() === ""
      || this.state.formData.identificationValue.value.trim() === ""
      || this.state.formData.email.value.trim() === ""
    // || this.state.formData.province_state.value.trim() === ""
    // || this.state.formData.district.value.trim() === ""
    // || this.state.formData.city_town.value.trim() === ""
    ) {

      common.notifyMessage("Please enter corporate details (required fields)");
      this.setState({
        completeCopUser: true
      });
      return false
    } else {

      let condition = false;

      if (Validator.mobileNumValidator(this.state.formData.mobileNo.value, null, 1)) {
        condition = false
      } else {
        common.notifyMessage("Please enter valid mobile number", 0, 2);
        condition = true
      }
      // email validator
      if (!condition) {
        if(this.state.formData.email.value.trim()!="") {
          let validateEmail = EmailValidator.validate(this.state.formData.email.value.trim());
          if (validateEmail) {
            condition = false
          } else {
            common.notifyMessage("Please enter valid email address", 0, 2);
            condition = true
          }
        } else {
          condition = false
        }
      }
      if (!condition) {

      }
      if (this.state.isVIP === true && this.state.rating === 0) {
        common.notifyMessage("Please give a point range to continue", 0, 2);
        condition = true
      }

      if (condition) {
        this.setState({
          completeCopUser: true
        });
        return false
      } else {
        this.setState({
          completeCopUser: false
        });
        return true;
      }
    }
  };

  validateEmg = () => {
    // if (this.state.formData.emgFullName.value.trim() === ""
    //   || this.state.formData.emgMobileNo.value.trim() === "") {
    //
    //   common.notifyMessage("Please enter Emergency contact details");
    //   this.setState({
    //     completeEmg: true
    //   });
    //   return false
    // } else {
    //
    //   let condition = false;
    //
    //   if (this.state.formData.emgMobileNo.value.trim() !== "") {
    //     if (this.state.formData.emgMobileNo.value.length >= 9) {
    //       condition = false
    //     } else {
    //       common.notifyMessage("Please enter valid mobile number", 0, 2);
    //       condition = true
    //     }
    //   }
    //
    //   if (condition) {
    //     this.setState({
    //       completeEmg: true
    //     });
    //     return false
    //   } else {
    //     this.setState({
    //       completeEmg: false
    //     });
    //     return true;
    //   }
    // }

    let condition = false;

    if (this.state.formData.emgMobileNo.value.trim() !== "") {
      if (Validator.mobileNumValidator(this.state.formData.emgMobileNo.value, null, 1)) {
        condition = false
      } else {
        common.notifyMessage("Please enter valid mobile number", 0, 2);
        condition = true
      }
    }

    if (condition) {
      this.setState({
        completeEmg: true
      });
      return false
    } else {
      this.setState({
        completeEmg: false
      });
      return true;
    }
  };

  validateCompany = () => {
    if (this.state.formData.empId.value.trim() === ""
      || this.state.formData.designation.value.trim() === ""
      || this.state.formData.department.value === "") {

      common.notifyMessage("Please enter Company related contact details");
      this.setState({
        completeCompany: true
      });
      return false
    } else {
      this.setState({
        completeCompany: false
      });
      return true;
    }

  };

  handleChange = (name, length) => event => {
    let value = '';

    if (name === "mobileNo" || name === "emgMobileNo") {
      let reg = /^\d+$/;
      if (reg.test(event.target.value) || event.target.value === "") {
        value = event.target.value;
      }
    } else {
      value = event.target.value;
    }

    const valid = Validator.textFieldValidator(value, length);

    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = valid;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });
  };
  dropDownChange = name => (event, {value}) => {
    const formData = {
      ...this.state.formData
    };
    formData[name].value = value;
    formData[name].valid = true;

    this.setState({
      formData: formData
    });

    let formValid = true;
    for (let inputIdentifier in formData) {
      formValid = formData[inputIdentifier].valid && formValid
    }

    this.setState({
      formValidate: formValid
    });
  };

  isVIPSelector = () => {
    this.setState({isVIP: !this.state.isVIP})
  };

  rateStarsVIP = (value) => {
    console.log(value.target.value)
    this.setState({rating: value.target.value})
  };

  getAllDepartment = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_DEPARTMENT(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            departmentData_list: response.data.departmentList
          })
        } else {
          this.setState({
            departmentData_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDepartment()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  submitForm = () => {

    const obj = {
      title: this.state.formData.title.value,
      firstName: this.state.formData.firstName.value,
      lastName: this.state.formData.lastName.value,
      gender: this.state.formData.gender.value,
      mobile: this.state.formData.mobileNo.value,
      identificationType: this.state.formData.identificationType.value,
      identificationValue: this.state.formData.identificationValue.value,

      email: this.state.formData.email.value,
     empId: 0,
      // department: this.state.formData.department.value,
      vip: this.state.isVIP,
      point:this.state.rating,
      designation: this.state.formData.designation.value,
      extention: this.state.formData.extension.value,
      staffId: null,

      addressEntities: [
        {
          line1: this.state.formData.address_line_1.value,
          line2: this.state.formData.address_line_2.value,
          city: this.state.formData.city_town.value,
          district: this.state.formData.district.value,
          province: this.state.formData.province_state.value,
          postalCode: this.state.formData.zip.value,
          country: "Sri Lanka",
          status: 1
        }
      ],
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.PUBLIC_SELECT_USER, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("User details successfully saved", 0);
          this.clearFields();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitForm()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllDepartment();
  }

  syncUsersFromAzureHandler = () => {

    swal({
      title: "Do you want to sync users from azure?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {

      switch (value) {
        case "action":
          this.syncUsersFromAzureHandler_();
          break;
        default:
          break;
      }
    });
  };

  syncUsersFromAzureHandler_ = () => {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.CORPORATE_SELECT_AZURE_USER(this.props.usr_obj.corporateId), null, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (response.data.message !== null && response.data.message !== "" && response.data.message !== undefined) {
            common.warningAlert(response.data.message, 0);
          }
          this.azurePopupHandler(response.data);

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.syncUsersFromAzureHandler_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    const rows = [];

    if (this.state.departmentData_list.length !== 0) {
      this.state.departmentData_list.map((row, index) => {
        rows.push(
          {
            key: index,
            text: row.name,
            value: row.departmentId,
          }
        )
      });
    }

    return (
      <div>
        {
          this.state.azurePopup ?
            <AzureSyncUsers closeModal={this.azurePopupHandler} azureResponse={this.state.azureResponse}/> : null
        }
        {
          this.state.usersUploadCSV ?
            <UploadCSV departmentArray={rows} closeModal={() => {
              this.setState({usersUploadCSV: false})
            }}/> : null
        }
        <div className={"top-buttons-wrapper"}>
          <button className={"sync-azure-btn upload-users-csv"} onClick={() => {
            this.setState({usersUploadCSV: true})
          }}>Upload users via CSV file &nbsp; <Icon name={"users"}/></button>
          <button className={"sync-azure-btn"} onClick={this.syncUsersFromAzureHandler}>Sync users from azure &nbsp;
            <Icon name={"users"}/>
          </button>
        </div>

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card className={this.state.completeCopUser ? "border-danger" : null}>
              <CardHeader>
                PUBLIC USER DETAILS
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  {/*corporate user details*/}
                  <Form>
                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"Title"}
                        placeholder={"Title"}
                        options={DropDownConst.userTitle}
                        onChange={this.dropDownChange('title')}
                      />
                      <DrpDwn
                        required
                        tagText={"Gender"}
                        placeholder={"Gender"}
                        options={DropDownConst.gender}
                        onChange={this.dropDownChange('gender')}
                      />

                    </Form.Group>
                  </Form>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"First Name"}
                        placeholder={"First Name"}
                        value={this.state.formData.firstName.value}
                        onChange={this.handleChange('firstName', 1)}
                      />

                      <TxtLbl
                        required
                        tagText={"Last Name"}
                        placeholder={"Last Name"}
                        value={this.state.formData.lastName.value}
                        onChange={this.handleChange('lastName', 1)}
                      />

                    </Form.Group>


                  </Form>

                  {/*corporate email/tel*/}
                  <Form className={"row_gap"}>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Email Address"}
                        placeholder={"Email Address"}
                        value={this.state.formData.email.value}
                        onChange={this.handleChange('email', 1)}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Mobile Number"}
                        placeholder={"Mobile NUmber"}
                        value={this.state.formData.mobileNo.value}
                        onChange={this.handleChange('mobileNo', 1)}
                      />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"Identification Type"}
                        placeholder={"Identification Type"}
                        options={DropDownConst.Identifications()}
                        onChange={this.dropDownChange('identificationType')}
                      />
                      <TxtLbl
                        required
                        tagText={"Identification Value"}
                        placeholder={"Identification Value"}
                        value={this.state.formData.identificationValue.value}
                        onChange={this.handleChange('identificationValue', 1)}
                      />

                    </Form.Group>
                  </Form>

                  {/*address*/}

                  <Form className={"row_gap"}>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        // required
                        tagText={"Address Line 1"}
                        placeholder={"Address Line 1"}
                        value={this.state.formData.address_line_1.value}
                        onChange={this.handleChange('address_line_1', 1)}
                      />

                      <TxtLbl
                        tagText={"Address Line 2"}
                        placeholder={"Address Line 2"}
                        value={this.state.formData.address_line_2.value}
                        onChange={this.handleChange('address_line_2', 1)}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <DrpDwn
                        // required
                        tagText={"Province/State"}
                        placeholder={"Province/State"}
                        value={this.state.formData.province_state.value}
                        options={this.props.provinces_list}
                        onChange={this.dropDownChange('province_state')}
                      />

                      <DrpDwn
                        // required
                        tagText={"District"}
                        placeholder={"Select district"}
                        value={this.state.formData.district.value}
                        // options={this.props.districs_list}
                        options={DropDownConst.districs}
                        onChange={this.dropDownChange('district')}
                      />
                    </Form.Group>


                    <Form.Group widths='equal'>
                      <TxtLbl
                        // required
                        tagText={"City/Town"}
                        placeholder={"City/Town"}
                        value={this.state.formData.city_town.value}
                        onChange={this.handleChange('city_town', 1)}
                      />
                      <TxtLbl
                        tagText={"Zip Code"}
                        placeholder={"Zip code"}
                        value={this.state.formData.zip.value}
                        onChange={this.handleChange('zip', 1)}
                      />
                    </Form.Group>

                    <Form.Group>
                      <strong style={{marginLeft: '8px', marginRight: '18px'}}>VIP</strong>
                      <br/>
                      <Checkbox toggle checked={this.state.isVIP} onChange={this.isVIPSelector}/>
                    </Form.Group>
                    {this.state.isVIP ?
                      <Form.Group>
                        <Label style={{marginLeft: '8px'}}>VIP Points</Label> <br/>
                        <Input
                          type='number'
                          placeholder={"VIP points"}
                          value={this.state.rating}
                          onChange={(value)=>{this.rateStarsVIP(value)}}
                        />
                      </Form.Group> : null}

                  </Form>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
          <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
            <Button className="px-5" onClick={this.isValidate}>Submit</Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  provinces_list: state.addCorporateReducer.provinces,
  districs_list: state.addCorporateReducer.districs,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

